import { getNormalOfferPrices } from './getNormalOfferPrices';
import {
  selectEtazhiBlackFridayPromoOffersData,
  selectIsEtazhiBlackFridayEnabled,
} from 'shared/selectors/etazhiBlackFriday';
import { getIsFlatSale, getIsRoomSale, getIsStartDatePassed } from 'shared/utils/etazhiBlackFriday';

import type { TJsonQuery } from 'packages/JsonQuery';
import type { IAppState } from 'shared/common/state';
import type { IGetNormalOfferPricesRequest } from 'shared/repositories/mortgage-subsidised-offers/v1/get-normal-offer-prices';
import type { IApplicationContext } from 'shared/types/applicationContext';
import type { IEtazhiBlackFridayPricesData } from 'shared/types/etazhiBlackFriday';

interface IParameters {
  jsonQuery: TJsonQuery;
  realtyOfferIds: IGetNormalOfferPricesRequest['realtyOfferIds'];
  getState: () => IAppState;
}

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-250843
 */
export async function fetchEtazhiBlackFridayOffersPrices(
  context: IApplicationContext,
  { jsonQuery, realtyOfferIds, getState }: IParameters,
): Promise<IEtazhiBlackFridayPricesData | null> {
  const state = getState();

  const isEnabled = selectIsEtazhiBlackFridayEnabled(state);

  /**
   * Выключена РСка всего проекта
   */
  if (!isEnabled) {
    return null;
  }

  const etazhiPromoOffersData = selectEtazhiBlackFridayPromoOffersData(state);

  /**
   * Нет данных РСки для "промо-полки" (вся РС выкл. или null), или
   * флаг enabled внутри РСки равен false
   */
  if (!etazhiPromoOffersData?.enabled) {
    return null;
  }

  const isStartDatePassed = getIsStartDatePassed(etazhiPromoOffersData);

  /**
   * Включена РСка компонента "Промо-полки", но дата старта
   * промо-кампании ещё не наступила
   */
  if (!isStartDatePassed) {
    return null;
  }

  const isFlatSale = getIsFlatSale(jsonQuery);
  const isRoomSale = getIsRoomSale(jsonQuery);

  /**
   * Неподходящая категория недвиж. и тип сделки
   */
  if (!isFlatSale && !isRoomSale) {
    return null;
  }

  const offerPrices = await getNormalOfferPrices({
    httpApi: context.httpApi,
    logger: context.logger,
    realtyOfferIds,
  });

  return offerPrices;
}
